import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export const labelVariants = cva(
    "sph-label flex items-center gap-2 leading-snug font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
    {
        variants: {
            inline: {
                true: 'font-normal',
            },
        },
        defaultVariants: {
            inline: false,
        },
    },
)

export type LabelVariants = VariantProps<typeof labelVariants>
